import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "../../../../../components/ui/label";
import { Switch } from "../../../../../components/ui/switch";
import Field from "../../../../../components/shared/Form/Field";
import Select from "../../../../../components/shared/inputs/Select";
import OptionsTable from "../../components/OptionsTable";
import SortInput from "../../components/SortInput";

const pageSizes: number[] = [10, 20, 30, 40, 50, 100];

function Settings({ columns }: any) {
    const { t } = useTranslation();

    const options = useMemo(() => [
        { label: t("daily-summary"), name: "timeSheet.hideDailySummary" },
        { label: t("weekly-summary"), name: "hideWeeklySummary" },
        { label: t("user-profile"), name: "hideUserProfile" },
        { label: t("clock-date-picker"), name: "timeSheet.hideClockDatePicker" },
    ], [t]);

    return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-6 tw-w-full">
            <div>
                <OptionsTable fields={options} />
            </div>

            <div className="tw-flex tw-flex-col">
                <Field name="defaultPageSize" label={t("default-page-size")}>
                    <Select allowClear>
                        {pageSizes.map((pageSize) => (
                            <Select.Item key={pageSize} value={String(pageSize)}>
                                {pageSize}
                            </Select.Item>
                        ))}
                    </Select>
                </Field>

                <SortInput columns={columns} />

                <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
                    <Field name="mandatoryNoteOnEdit" valuePropName="checked" className="tw-mb-0">
                        <Switch id="mandatoryNoteOnEdit" />
                    </Field>
                    <Label className="tw-mb-0">
                        {t("mandatory-note-on-edit")}
                    </Label>
                </div>

                <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
                    <Field name="mandatoryNoteOnCreate" valuePropName="checked" className="tw-mb-0">
                        <Switch id="mandatoryNoteOnCreate" />
                    </Field>
                    <Label className="tw-mb-0">
                        {t("mandatory-note-on-create")}
                    </Label>
                </div>
            </div>
        </div>
    );
}

export default Settings;
